/* Crumb & Copper – header behaviour: scroll state, mega menu (hover intent, touch, keyboard)
   and the mobile drawer. Used by sections/rm-header.liquid. */
(function () {
  function each(scope, selector, fn) {
    Array.prototype.forEach.call(scope.querySelectorAll(selector), fn);
  }
  function claim(el) {
    if (el.dataset.rmReady) return false;
    el.dataset.rmReady = '1';
    return true;
  }

  /* ---------- Header ---------- */
  function initHeader(root) {
    if (!claim(root)) return;
    var lastPointer = 'mouse';

    function onScroll() { root.classList.toggle('is-scrolled', window.scrollY > 8); }
    function setHeight() { document.documentElement.style.setProperty('--header-height', root.offsetHeight + 'px'); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setHeight);
    onScroll();
    setHeight();

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var link = item.querySelector('.rm-nav__link');
      if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) item.removeAttribute('data-touch-open');
    }
    function closeAll(except) {
      each(root, '[data-mega].is-open', function (item) { if (item !== except) setOpen(item, false); });
    }

    root.addEventListener('pointerdown', function (event) { lastPointer = event.pointerType || 'mouse'; });

    each(root, '[data-mega]', function (item) {
      var openTimer = null;
      var closeTimer = null;
      var link = item.querySelector('.rm-nav__link');
      item.addEventListener('mouseenter', function () {
        if (lastPointer === 'touch') return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { closeAll(item); setOpen(item, true); }, 70);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { setOpen(item, false); }, 160);
      });
      item.addEventListener('focusin', function () { closeAll(item); setOpen(item, true); });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
      if (link) {
        link.addEventListener('click', function (event) {
          if (lastPointer !== 'touch' || item.hasAttribute('data-touch-open')) return;
          event.preventDefault();
          closeAll(item);
          setOpen(item, true);
          item.setAttribute('data-touch-open', '');
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll(null);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer(drawer) {
    if (!claim(drawer)) return;
    var panel = drawer.querySelector('.rm-drawer__panel');
    var openers = document.querySelectorAll('[data-rm-drawer-open][aria-controls="' + drawer.id + '"]');
    var lastFocus = null;

    function setExpanded(value) {
      Array.prototype.forEach.call(openers, function (button) { button.setAttribute('aria-expanded', value); });
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      document.body.classList.add('rm-lock');
      setExpanded('true');
      var close = drawer.querySelector('.rm-drawer__close');
      if (close) setTimeout(function () { close.focus(); }, 50);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      document.body.classList.remove('rm-lock');
      setExpanded('false');
      if (lastFocus) lastFocus.focus();
    }

    drawer.setAttribute('inert', '');
    Array.prototype.forEach.call(openers, function (button) { button.addEventListener('click', open); });
    each(drawer, '[data-rm-drawer-close]', function (el) { el.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var focusable = panel.querySelectorAll('a[href], button, summary, input');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.matchMedia('(min-width: 1200px)').addEventListener('change', function (mq) {
      if (mq.matches && drawer.classList.contains('is-open')) close();
    });
  }

  function init(scope) {
    each(scope, '[data-rm-header]', initHeader);
    each(scope, '[data-rm-drawer]', initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();